import "./index.scss";
import { ColorStyleGuide } from "./ColorStyleGuide";
import { LogoStyleGuide } from "./LogoStyleGuide";
import { TypographyStyleGuide } from "./TypographyStyleGuide";

export default function ClxStyleGuide() {
  return (
    <div className="clx-style-guide">
      <ColorStyleGuide />
      <TypographyStyleGuide />
      <LogoStyleGuide />
    </div>
  );
}
